import LaporanPeluang from './LaporanPeluang';

export default LaporanPeluang;
